import { Component } from '@angular/core';

@Component({
    selector: 'ds-root',
    template: `<router-outlet></router-outlet>`,
    standalone: false
})
export class AppComponent {
}


